import React from 'react';
import image from './storybook.png';

const StorybookLogo = () => <img className='img-fluid' src={image} alt='storybook' />;

export default StorybookLogo;
